import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faBaby, faCalendarAlt, faHome, faPlaneDeparture, faClock, faTint, faWind, faThermometerHalf, faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
 
library.add(fab, faBaby, faCalendarAlt, faPlaneDeparture, faHome, faClock, faTint, faWind, faThermometerHalf, faMapMarkerAlt)